import { render, staticRenderFns } from "./AppDrawerHeader.vue?vue&type=template&id=a3844d86&scoped=true&"
import script from "./AppDrawerHeader.vue?vue&type=script&lang=ts&"
export * from "./AppDrawerHeader.vue?vue&type=script&lang=ts&"
import style0 from "./AppDrawerHeader.vue?vue&type=style&index=0&id=a3844d86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3844d86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAppBar,VBtn,VIcon,VSpacer,VToolbarTitle})
